import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../api-services/api-service';

// Thunk for creating event
export const createEvent = createAsyncThunk('events/createEvent', async ({ adminData, payload }) => {
  const { id: empId, acessToken } = adminData;
  const response = await apiService.createEvent(empId, acessToken, payload);
  return response;
});

// NEW Thunk for fetching event list
export const fetchEventsList = createAsyncThunk(
  'events/fetchEventsList',
  async (adminData, { rejectWithValue }) => {
    try {
      const { id: empId, acessToken } = adminData;
      const response = await apiService.fetchEventsList(empId, acessToken);
      return response;
    } catch (error) {
      // Return the error message for rejected action
      return rejectWithValue(error.message || 'Failed to fetch events');
    }
  }
);


// Update Event Thunk
export const updateEvent = createAsyncThunk(
  'events/updateEvent',
  async ({ adminData, payload }, { rejectWithValue }) => {
    try {
      const { id: empId, acessToken } = adminData;
      const response = await apiService.updateEvent(empId, acessToken, payload);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to update event');
    }
  }
);

// Delete Event Thunk
export const deleteEvent = createAsyncThunk(
  "events/deleteEvent",
  async ({ adminData, eventId }, { rejectWithValue }) => {
    try {
      const { id: empId, acessToken } = adminData;
      const response = await apiService.deleteEvent(empId, acessToken, eventId);
      // Ensure response has success boolean
      return response
    } catch (error) {
      return rejectWithValue(error.message || "Failed to delete event");
    }
  }
);



const eventsSlice = createSlice({
  name: 'events',
  initialState: {
    loading: false,
    error: null,
    success: false,
    eventsList: {  // Change from array to object
      upcomingEvents: [],
      previousEvents: []
    },      // Add state to hold fetched events
  },
  reducers: {
    clearEventState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Create event
      .addCase(createEvent.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createEvent.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(createEvent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.success = false;
      })

      // Fetch events list cases (new)
      .addCase(fetchEventsList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEventsList.fulfilled, (state, action) => {
        state.loading = false;
       // Store the entire data object from API response
        state.eventsList = action.payload.data || {
          upcomingEvents: [],
          previousEvents: [],
          allEvents: []
        };
        state.error = null;
      })
      .addCase(fetchEventsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })

       // Update Event
      .addCase(updateEvent.pending, (state) => {
        state.loading = true; state.error = null; state.success = false;
      })
      .addCase(updateEvent.fulfilled, (state) => {
        state.loading = false; state.success = true;
      })
      .addCase(updateEvent.rejected, (state, action) => {
        state.loading = false; state.error = action.payload || action.error.message; state.success = false;
      })

      // Delete Event
      .addCase(deleteEvent.pending, (state) => {
        state.loading = true; state.error = null; state.success = false;
      })
      .addCase(deleteEvent.fulfilled, (state) => {
        state.loading = false; state.success = true;
      })
      .addCase(deleteEvent.rejected, (state, action) => {
        state.loading = false; state.error = action.payload || action.error.message; state.success = false;
      });

  },
});

export const { clearEventState } = eventsSlice.actions;
export default eventsSlice.reducer;

